export const ICON_APPROVED_HTML = '<span class="icon-approved"><span class="path1"></span><span class="path2"></span></span>';
export const ICON_REQUESTED_HTML = '<span class="icon-requested"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>';
export const DIV_ALWAYS_PAINT = '<div class="always-paint">';
export const DIV_LAST_DAY = '<div class="last-day">';



// WEBPACK FOOTER //
// ./client/app/common/utils/calendarRenderLibrary/calendar.templates.js